// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"202":"aaa09f10","346":"bdd8ee93","369":"5400b244","485":"726fcc45","918":"5f90e272"}[chunkId] + ".chunk.css";
};